module.exports = __webpack_public_path__ + "static/media/480.21c62f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-leaf/light/480.png
// module id = 2234
// module chunks = 2